import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class UploadImageService {
  public server = environment.APIEndpoint + 'api/v3/uploadFiles';
  public deviceMetaInfo = {
    "appVersion":"",
    "deviceCountry":"India",
    "deviceCity":"",
    "deviceId":localStorage.getItem("deviceId"),
    "deviceModel":"",
    "platform":"WEB",
    "deviceOSVersion":""};
  constructor(private http: HttpClient,private storageService:StorageService) { }
  public upload(file, moduleName, fileType) {
    let UPLOAD_FILE = this.server;
    let httpOptions = new HttpHeaders({
      'Authorization': 'Bearer ' + this.storageService.getAccessToken(),
      'Device-Meta-Info' : JSON.stringify(this.deviceMetaInfo),
    });
    const formData: FormData = new FormData();
    formData.append("file", file);
    return this.http.post(UPLOAD_FILE + "/" + moduleName + "/" + fileType, formData, { headers: httpOptions });
  }
}
